// extracted by css-extract-rspack-plugin
export default {"myAccountContainer":"MyAccountForm_myAccountContainer__zrFgl"};